import {
  CreateQrRegistrationData,
  QrRegistrationAction,
  QrRegistrationResult,
} from './actionType'

export const createQrRegistration = (
  data: CreateQrRegistrationData,
  callback: (result: QrRegistrationResult) => void,
  onError?: () => void,
): QrRegistrationAction => ({
  type: 'qrRegistration/CREATE_QR_REGISTRATION',
  data,
  callback,
  onError,
})

export const deactivateQrRegistration = (
  id: number,
  callback: (result: QrRegistrationResult) => void,
  onError?: () => void,
): QrRegistrationAction => ({
  type: 'qrRegistration/DEACTIVATE_QR_REGISTRATION',
  id,
  callback,
  onError,
})
